import { Injectable } from '@angular/core';
import {UrlQueryService} from '../../../../common/url-query/url-query.service';
import {map} from 'rxjs/operators';
import {OfflineNetworkApiService} from '../network/offline-network-api.service';
import {HttpClient} from '@angular/common/http';
import {MetaDataService} from '../../../../metaData/meta-data.service';
import {PeerConnectionFilterService} from '../../../../filters/peer-connection/peer-connection-filter.service';

@Injectable({
  providedIn: 'root'
})
export class OfflinePeerConnectionApiService {

  constructor(private http: HttpClient,
              private offlineNetworkApiService: OfflineNetworkApiService,
              private metaDataService: MetaDataService) {}

  readonly pconUrl: string = 'planning/peerCon';

  public getPConsForMap(params: any = {}): Promise<any> {
    return this.offlineNetworkApiService.getOfflineMap().pipe(map(mapData => {
      const peerConnections = OfflineNetworkApiService.objectToArray(mapData.peerConnections);

      return this.filterPeerConnections(peerConnections, params);
    })).toPromise();
  }

  public getPconForMap(id: number): Promise<any> {
    return this.offlineNetworkApiService.getOfflineMap().pipe(map(mapData => {
      return mapData.peerConnections[id];
    })).toPromise();
  }

  public getPcons(params: any = {}): Promise<any> {
    const url = UrlQueryService.addQueryParameters(this.pconUrl, {filter: params});
    return this.http.get(url).toPromise();
  }

  public getPcon(id: number): Promise<any> {
    return this.http.get(`${this.pconUrl}/${id}`).toPromise();
  }


  public addPcon(pCon): Promise<any> {
    return this.http.post(this.pconUrl, pCon).toPromise();
  }

  public editPcon(pCon: any, id: number): Promise<any> {
    const url = `${this.pconUrl}/${id}`;
    return this.http.put(url, pCon).toPromise();
  }

  public unlockPCon(id: number): Promise<any> {
    const url = `${this.pconUrl}/${id}/lock`;
    return this.http.put(url, {lock: this.metaDataService.PeerConnectionAdminStatus.UNLOCKED.value}).toPromise();
  }

  public lockPCon(id: number): Promise<any> {
    const url = `${this.pconUrl}/${id}/lock`;
    return this.http.put(url, {lock: this.metaDataService.PeerConnectionAdminStatus.LOCKED.value}).toPromise();
  }

  public lockIncomingPCon(id: number): Promise<any> {
    const url = `${this.pconUrl}/${id}/lock`;
    return this.http.put(url, {lock: this.metaDataService.PeerConnectionAdminStatus.LOCKED_INCOMING.value}).toPromise();
  }

  public lockOutgoingPCon(id: number): Promise<any> {
    const url = `${this.pconUrl}/${id}/lock`;
    return this.http.put(url, {lock: this.metaDataService.PeerConnectionAdminStatus.LOCKED_OUTGOING.value}).toPromise();
  }

  public lockPCons(ids): Promise<any> {
    const uri = `${this.pconUrl}/lock`;
    const url = UrlQueryService.addQueryParameters(uri, {filter: {id: {value: ids, operator: '='}}});

    return this.http.put(url, {lock: this.metaDataService.PeerConnectionAdminStatus.LOCKED.value}).toPromise();
  }

  public unlockPCons(ids): Promise<any> {
    const uri = `${this.pconUrl}/lock`;
    const url = UrlQueryService.addQueryParameters(uri, {filter: {id: {value: ids, operator: '='}}});

    return this.http.put(url, {lock: this.metaDataService.PeerConnectionAdminStatus.UNLOCKED.value}).toPromise();
  }

  public lockIncomingPCons(ids): Promise<any> {
    const uri = `${this.pconUrl}/lock`;
    const url = UrlQueryService.addQueryParameters(uri, {filter: {id: {value: ids, operator: '='}}});

    return this.http.put(url, {lock: this.metaDataService.PeerConnectionAdminStatus.LOCKED_INCOMING.value}).toPromise();
  }

  public lockOutgoingPCons(ids): Promise<any> {
    const uri = `${this.pconUrl}/lock`;
    const url = UrlQueryService.addQueryParameters(uri, {filter: {id: {value: ids, operator: '='}}});

    return this.http.put(url, {lock: this.metaDataService.PeerConnectionAdminStatus.LOCKED_OUTGOING.value}).toPromise();
  }

  public deletePCon(id): Promise<any> {
    const url = `${this.pconUrl}/${id}`;
    return this.http.delete(url).toPromise();
  }

  private filterPeerConnections(pCons, params): void {
    return (params && params.mapFilter) ?
      PeerConnectionFilterService.mapFilter(pCons, params.searchObject) : pCons;
  }
}
